<template>
  <div id="alert_modal" class="modal-wrap delivery_address">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_txt">배송지 추가</div>
      </div>

      <div class="modal_body">
        <div class="modal_contents">
          <div class="insert_area">
            <div class="nl">
              <div class="nl_title">이름</div>
              <div class="nl_input">
                <div>
                  <input
                    class="input"
                    type="text"
                    name=""
                    value=""
                    placeholder="최대 10글자 이내로 작성해주세요."
                  />
                </div>
              </div>
            </div>
            <div class="nl">
              <div class="nl_title">연락처</div>
              <div class="nl_input">
                <div>
                  <CustomSelect
                    :options="hp"
                    defaultOption="010"
                    @update:selected="handleSelectHp"
                  />
                  <input
                    class="input"
                    type="text"
                    name=""
                    value=""
                    placeholder="최대 10글자 이내로 작성해주세요."
                  />
                </div>
              </div>
            </div>
            <div class="nl">
              <div class="nl_title">주소</div>
              <div class="nl_input">
                <div>
                  <input
                    class="input"
                    type="text"
                    name=""
                    value=""
                    placeholder="주소 찾기로 입력해주세요."
                    readonly
                  />
                  <div class="search">주소찾기</div>
                </div>
                <div>
                  <input
                    class="input"
                    type="text"
                    name=""
                    value=""
                    placeholder="상세 주소를 입력해주세요."
                  />
                </div>
                <div class="check_box">
                  <input
                    id="default_address"
                    type="checkbox"
                    name="d_address"
                  />
                  <label for="default_address"></label>
                  <label for="default_address" class="default_address"
                    >기본 배송지로 설정</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal_footer">
        <div class="btn_area">
          <button @click="close" class="btn_basic">저장</button>
          <button @click="close" class="btn_basic close_btn">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from './CustomSelect.vue'

export default {
  name: 'AddressAdd',
  components: {
    CustomSelect,
  },
  setup(_, { emit }) {
    const hp = ['010', '011', '016', '017', '019']

    const handleSelectHp = (selected) => {
      alert(`선택된 값은: ${selected}`)
    }

    const close = () => {
      emit('close')
    }

    return {
      hp,
      handleSelectHp,
      close,
    }
  },
}
</script>

<style></style>
